import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid, Tooltip } from '@mui/material';
import { IconButton, Typography } from '@totalsoft/rocket-ui';
import { get } from '@totalsoft/change-tracking-react';
import { getIntOrDefaultValue } from 'utils/functions';
import { StyledTableRow, StyledTableBodyCell } from 'components/common/Styles';
import FlexBox from 'components/common/FlexBox';
import { financialProductRuleCommissionModalVar } from './variables';

const FinancialProductRulesEditDetailsCommissionsTableRow = ({
  canWrite,
  commissionLens,
  onDelete
}) => {
  const [t] = useTranslation();
  const commission = commissionLens |> get;

  return (
    <StyledTableRow>
          <StyledTableBodyCell colSpan={2}>
          <Tooltip
          title={
            <FlexBox direction='column' p={0.5} gap={0.5}>
              <Typography>
                {t('FinancialProduct.Details.Rules.Details.Commissions.AssignedTo')}: <strong>{commission.assignToRoleName}</strong>
              </Typography>
              <Typography>
                {t('FinancialProduct.Details.Rules.Details.Commissions.CalculatedAt')}: <strong>{commission.calcTypeName}</strong>
              </Typography>
              <Typography>
                {t('FinancialProduct.Details.Rules.Details.Commissions.CalculationMethod')}: <strong>{commission.calculationMethodName}</strong>
              </Typography>
              <Typography>
                {t('FinancialProduct.Details.Rules.Details.Commissions.ReadOnly')}: <strong>{(commission.readOnlyYN) === true ? t('ListBrowser.Yes') : t('ListBrowser.No')}</strong>
              </Typography>
              <Typography>
                {t('FinancialProduct.Details.Rules.Details.Commissions.Default')}: <strong>{(commission.implicit) === true ? t('ListBrowser.Yes') : t('ListBrowser.No')}</strong>
              </Typography>
              <Typography>
                {t('FinancialProduct.Details.Rules.Details.Commissions.Mandatory')}: <strong>{(commission.mandatory) === true ? t('ListBrowser.Yes') : t('ListBrowser.No')}</strong>
              </Typography>
            </FlexBox>
          }
          placement='bottom-start'
        >{commission.commissionName}</Tooltip>
            </StyledTableBodyCell>
          <StyledTableBodyCell>{commission.commissionDefaultPercent}</StyledTableBodyCell>
          <StyledTableBodyCell>{commission.commissionDefaultValue}</StyledTableBodyCell>
          <StyledTableBodyCell>{commission.appliedToName}</StyledTableBodyCell>
          <StyledTableBodyCell align='right'>
            <Grid container wrap='nowrap' justifyContent='flex-end'>
              <IconButton
                type='edit'
                fontSize='medium'
                color='transparent'
                tooltip={t('FinancialProduct.Edit')}
                disabled={!canWrite}
                onClick={() => financialProductRuleCommissionModalVar({ open: true, 
                  item: {
                    financialProductRuleCommissionId: commission.financialProductRuleCommissionId,
                    financialProductRuleId: commission.financialProductRuleId,
                    commissionId: commission.commissionId,
                    commissionName: commission.commissionName,
                    commissionDefaultPercent: commission.commissionDefaultPercent,
                    commissionDefaultValue: commission.commissionDefaultValue,
                    appliedToId: commission.appliedToId,
                    appliedToName: commission.appliedToName,
                    assignToRoleId: commission.assignToRoleId,
                    assignToRoleName: commission.assignToRoleName,
                    calcTypeName: commission.calcTypeName,
                    calculationMethodId: commission.calculationMethodId,
                    calculationMethodName: commission.calculationMethodName,
                    readOnlyYN: commission.readOnlyYN,
                    implicit: commission.implicit,
                    mandatory: commission.mandatory,
                    usesValue: getIntOrDefaultValue(commission.commissionDefaultPercent, 0) === 0,
                    usesPercent: getIntOrDefaultValue(commission.commissionDefaultValue, 0) === 0,
                  } 
              })} 
                />
              <IconButton
                type='delete'
                fontSize='medium'
                color='transparent'
                tooltip={t('FinancialProduct.Delete')} c
                onClick={onDelete(commission.financialProductRuleCommissionId)}
                disabled={!canWrite}
              />
            </Grid>
          </StyledTableBodyCell>
    </StyledTableRow>
  );
};

FinancialProductRulesEditDetailsCommissionsTableRow.propTypes = {
  canWrite: PropTypes.bool.isRequired,
  commissionLens: PropTypes.object,
  onDelete: PropTypes.func.isRequired
};

export default FinancialProductRulesEditDetailsCommissionsTableRow;

